/** Ruta del instructivo de Autogestión en el portal (instancia.extendeal.com). */
const SELF_MANAGEMENT_DOC_PATH = '/doc/self-management-tutorial.html';

/**
 * Origen público del portal: https://{instancia}.extendeal.com
 * (staging, ar, br, mx, etc.) según `REACT_APP_SCI_HOST_URL`.
 */
function getPortalPublicOrigin(): string | null {
  const raw = (process.env.REACT_APP_SCI_HOST_URL || '').trim();
  if (!raw) {
    return null;
  }
  try {
    const withProto = raw.includes('://') ? raw : `https://${raw}`;
    const u = new URL(withProto);
    const host = u.hostname.toLowerCase();
    if (!host.endsWith('extendeal.com')) {
      return null;
    }
    return `https://${host}`;
  } catch {
    return null;
  }
}

/** URL completa del instructivo HTML en el dominio de la instancia. */
export function getSelfManagementDocUrl(): string {
  const portalOrigin = getPortalPublicOrigin();
  if (portalOrigin) {
    return `${portalOrigin}${SELF_MANAGEMENT_DOC_PATH}`;
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${SELF_MANAGEMENT_DOC_PATH}`;
  }
  return SELF_MANAGEMENT_DOC_PATH;
}

/**
 * Ayuda del header / menú: en Autogestión (`/products`) → instructivo en el portal;
 * en Ventas y resto → URL de soporte (p. ej. video) en env.
 */
export function getHelpSupportUrl(pathname: string): string {
  if (pathname.startsWith('/products')) {
    return getSelfManagementDocUrl();
  }
  return process.env.REACT_APP_PORTAL_SUPPORT_URL ?? '';
}
